import { LitElement, html, css } from 'lit';
import { customElement, property, state } from 'lit/decorators.js';

import { nsSharedStyles, nsAnimationStyles, nsLayoutStyles } from '../ns-styles/index.js';

@customElement('ns-main-logo')
export class NsMainLogo extends LitElement {
  @property()
  classes: string = ' mt-3';

  @state()
  login: boolean = false;

  static styles = [
    nsLayoutStyles,
    nsSharedStyles,
    nsAnimationStyles,
    css`
      :host {
        display: block;
        color: var(--ns-theme-white);

        text-align: center;
      }
    `,
  ];

  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;

    this.addEventListener('start-animation', async (ev: Event) => {
      this.__startAnimation(ev as CustomEvent);
    });

    if (this.login) {
      this.classes = ' mb-3 login';
    }
  }

  private async __startAnimation(ev: CustomEvent) {
    const logoElement = this.renderRoot.querySelector('.main-logo-animation');
    if (!logoElement) throw new Error('Could not find main logo animation element');

    const upwardLogo = this.renderRoot.querySelector('.logo .upward-logo') as HTMLElement;
    const downwardLogo = this.renderRoot.querySelector('.logo .downward-logo') as HTMLElement;
    const upwardText = this.renderRoot.querySelector('.text .upward-text') as HTMLElement;
    const downwardText = this.renderRoot.querySelector('.text .downward-text') as HTMLElement;

    const animationFunction = ev.detail;
    logoElement.classList.add('start');
    // Logo animation
    const upwardLogoAnimation = upwardLogo.animate(
      [
        {
          transform: 'translate(0, 100%)',
        },
        {
          transform: 'translate(0, 0)',
        },
      ],
      {
        duration: 1000,
        easing: animationFunction ? animationFunction : 'cubic-bezier(0.43, 0.12, 0.39, 0.96)',
      },
    );
    const downwardLogoAnimation = downwardLogo.animate(
      [
        {
          transform: 'translate(0, -100%)',
        },
        {
          transform: 'translate(0, 0)',
        },
      ],
      {
        duration: 1000,
        easing: animationFunction ? animationFunction : 'cubic-bezier(0.43, 0.12, 0.39, 0.96)',
      },
    );

    // Text animation
    const upwardTextAnimation = upwardText.animate(
      [
        {
          transform: 'translate(0, 100%)',
        },
        {
          transform: 'translate(0, 0)',
        },
      ],
      {
        duration: 1000,
        easing: animationFunction ? animationFunction : 'cubic-bezier(0.43, 0.12, 0.39, 0.96)',
      },
    );
    const downwardTextAnimation = downwardText.animate(
      [
        {
          transform: 'translate(0, -100%)',
        },
        {
          transform: 'translate(0, 0)',
        },
      ],
      {
        duration: 1000,
        easing: animationFunction ? animationFunction : 'cubic-bezier(0.43, 0.12, 0.39, 0.96)',
      },
    );

    upwardLogoAnimation.play();
    await upwardLogoAnimation.finished;
    await downwardLogoAnimation.finished;
    await upwardTextAnimation.finished;
    await downwardTextAnimation.finished;
  }

  render() {
    return html`
      <div class="layout inline horizontal center-center w-100 main-logo-animation${this.classes}">
        <div class="layout vertical">
          <div class="layout horizontal logo">
            <div class="upward-logo flex">
              <img class="upward-logo" alt="" aria-hidden="true" src="/images/animation-asset/white-upward-arrow.svg" />
            </div>
            <div class="downward-logo flex">
              <img
                class="downward-logo"
                alt=""
                aria-hidden="true"
                src="/images/animation-asset/white-downward-arrow.svg"
              />
            </div>
          </div>
          <div class="layout horizontal text">
            <div class="upward-text flex">
              <div class="text">node</div>
            </div>
            <div class="downward-text flex">
              <div class="text">Stream</div>
            </div>
          </div>
        </div>
      </div>
    `;
  }
}
